module.exports = __webpack_public_path__ + "static/cases-tile-1-1-8a355633cef406cd414316cec78400c4.png";